/** Mirrors `data/enums.json`, which was read out of the IL2CPP dump. */

export enum ColorType {
  Black = 0,
  Blue = 1,
  Green = 2,
  Orange = 3,
  Purple = 4,
  Red = 5,
  Turquoise = 6,
  Yellow = 7,
  White = 8,
  Grey = 9,
  Brown = 10,
  Pink = 11,
  None = 12,
}

export enum LevelDifficulty {
  Normal = 0,
  Hard = 1,
  VeryHard = 2,
}

export enum BoxSizeEnum {
  Small = 0,
  Medium = 1,
  Large = 2,
}

export enum BoxTypeEnum {
  Empty = 0,
  Hidden = 1,
  Ice = 2,
}

/** `Dreamteck.Splines.Spline.Type` — TypeDefIndex 12259 in the dump. */
export enum SplineType {
  CatmullRom = 0,
  BSpline = 1,
  Bezier = 2,
  Linear = 3,
}

/** `SplineDirection` — TypeDefIndex 8589. */
export enum SplineDirection {
  Clockwise = 0,
  CounterClockwise = 1,
}

// Bus capacity lives in `src/game/tuning.ts` — the shipped values are
// 18 / 36 / 54, not the 12 / 24 / 36 named in the `capacityOverride` tooltip.
// See the comment there for how the level data settles it.

/**
 * 🔍 `SoundTypeEnum` — `dump.cs`:707587-707624, verbatim and complete.
 *
 * Ported as an enum rather than as bare numbers because the decompile calls
 * `SoundService.Play` with the literal: `Play(0xc)`, `Play(0xd)`, `Play(10)`.
 * Those literals are unreadable on their own, and two of them are the ice
 * branch. See `SOUND_CLIPS` for which `.ogg` each one plays and how that was
 * recovered.
 */
export enum SoundTypeEnum {
  LevelFail = 0,
  Confetti = 1,
  ButtonClick = 2,
  Unlock = 3,
  Jump0 = 4,
  Jump1 = 5,
  Jump2 = 6,
  Jump3 = 7,
  Jump4 = 8,
  BusClick = 9,
  WrongClickFeedback = 10,
  HiddenReveal = 11,
  IceCountdown = 12,
  IceBreak = 13,
  BusHit1 = 14,
  BusHit2 = 15,
  BusHit3 = 16,
  BusMove = 17,
  BusComplete = 18,
  BusExiting = 19,
  BreakGlass = 20,
  SafeBreak = 21,
  SafeCoinBreak = 22,
  PropellerFly = 23,
  CurtainOpen = 24,
  CurtainChainBreak = 25,
  BigCubeDestroy = 26,
  CapacityBooster = 27,
  HardLevelSound = 28,
  SuccessPanel = 29,
  CoinHit = 30,
  CoinEarned = 31,
  HeartHit = 32,
  CapacityKeepPlaying = 33,
  GlassBreak = 34,
  RopeCut = 35,
  WrongBallHit = 36,
}
